import React from 'react'

const Auth = ({ children }) => (
  <div className="flex min-h-screen flex-col items-center bg-muted px-6 pt-16 pb-6 md:px-10 md:pt-24 md:pb-10">
    <div className="flex w-full max-w-sm flex-col gap-6">
      {children}
    </div>
  </div>
)

export default Auth
